/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type CreateHchbPatientRequest201Response,
    CreateHchbPatientRequest201ResponseFromJSON,
    CreateHchbPatientRequest201ResponseToJSON,
} from '../models/CreateHchbPatientRequest201Response';
import {
    type CreateHchbPatientRequestBody,
    CreateHchbPatientRequestBodyFromJSON,
    CreateHchbPatientRequestBodyToJSON,
} from '../models/CreateHchbPatientRequestBody';
import {
    type CreateKinnserPatientRequest,
    CreateKinnserPatientRequestFromJSON,
    CreateKinnserPatientRequestToJSON,
} from '../models/CreateKinnserPatientRequest';
import {
    type CreateMatrixCareHomeHealthAdmission201Response,
    CreateMatrixCareHomeHealthAdmission201ResponseFromJSON,
    CreateMatrixCareHomeHealthAdmission201ResponseToJSON,
} from '../models/CreateMatrixCareHomeHealthAdmission201Response';
import {
    type CreateMatrixCareHomeHealthAdmissionRequest,
    CreateMatrixCareHomeHealthAdmissionRequestFromJSON,
    CreateMatrixCareHomeHealthAdmissionRequestToJSON,
} from '../models/CreateMatrixCareHomeHealthAdmissionRequest';
import {
    type CreateMatrixCareHomeHealthPatientRequest,
    CreateMatrixCareHomeHealthPatientRequestFromJSON,
    CreateMatrixCareHomeHealthPatientRequestToJSON,
} from '../models/CreateMatrixCareHomeHealthPatientRequest';
import {
    type CreatePractitioner200Response,
    CreatePractitioner200ResponseFromJSON,
    CreatePractitioner200ResponseToJSON,
} from '../models/CreatePractitioner200Response';
import {
    type CreatePractitionerRequest,
    CreatePractitionerRequestFromJSON,
    CreatePractitionerRequestToJSON,
} from '../models/CreatePractitionerRequest';
import {
    type FindAllHchbAdmissionCoordinators200Response,
    FindAllHchbAdmissionCoordinators200ResponseFromJSON,
    FindAllHchbAdmissionCoordinators200ResponseToJSON,
} from '../models/FindAllHchbAdmissionCoordinators200Response';
import {
    type FindAllHchbBranches200Response,
    FindAllHchbBranches200ResponseFromJSON,
    FindAllHchbBranches200ResponseToJSON,
} from '../models/FindAllHchbBranches200Response';
import {
    type FindAllHchbFacilities200Response,
    FindAllHchbFacilities200ResponseFromJSON,
    FindAllHchbFacilities200ResponseToJSON,
} from '../models/FindAllHchbFacilities200Response';
import {
    type FindAllHchbPatientRequests200Response,
    FindAllHchbPatientRequests200ResponseFromJSON,
    FindAllHchbPatientRequests200ResponseToJSON,
} from '../models/FindAllHchbPatientRequests200Response';
import {
    type FindAllHchbPayorSources200Response,
    FindAllHchbPayorSources200ResponseFromJSON,
    FindAllHchbPayorSources200ResponseToJSON,
} from '../models/FindAllHchbPayorSources200Response';
import {
    type FindAllHchbPayorTypes200Response,
    FindAllHchbPayorTypes200ResponseFromJSON,
    FindAllHchbPayorTypes200ResponseToJSON,
} from '../models/FindAllHchbPayorTypes200Response';
import {
    type FindAllHchbPhysicians200Response,
    FindAllHchbPhysicians200ResponseFromJSON,
    FindAllHchbPhysicians200ResponseToJSON,
} from '../models/FindAllHchbPhysicians200Response';
import {
    type FindAllMatrixCareHomeHealthAdmissions200Response,
    FindAllMatrixCareHomeHealthAdmissions200ResponseFromJSON,
    FindAllMatrixCareHomeHealthAdmissions200ResponseToJSON,
} from '../models/FindAllMatrixCareHomeHealthAdmissions200Response';
import {
    type FindAllMatrixCareHomeHealthAdmissions400Response,
    FindAllMatrixCareHomeHealthAdmissions400ResponseFromJSON,
    FindAllMatrixCareHomeHealthAdmissions400ResponseToJSON,
} from '../models/FindAllMatrixCareHomeHealthAdmissions400Response';
import {
    type FindAllMatrixCareHomeHealthCopySources200Response,
    FindAllMatrixCareHomeHealthCopySources200ResponseFromJSON,
    FindAllMatrixCareHomeHealthCopySources200ResponseToJSON,
} from '../models/FindAllMatrixCareHomeHealthCopySources200Response';
import {
    type FindCurrentHomeHealthCertification200Response,
    FindCurrentHomeHealthCertification200ResponseFromJSON,
    FindCurrentHomeHealthCertification200ResponseToJSON,
} from '../models/FindCurrentHomeHealthCertification200Response';
import {
    type FindOneHchbPatientDetails200Response,
    FindOneHchbPatientDetails200ResponseFromJSON,
    FindOneHchbPatientDetails200ResponseToJSON,
} from '../models/FindOneHchbPatientDetails200Response';
import {
    type FindOneMatrixCareHomeHealthAdmissionDemographics200Response,
    FindOneMatrixCareHomeHealthAdmissionDemographics200ResponseFromJSON,
    FindOneMatrixCareHomeHealthAdmissionDemographics200ResponseToJSON,
} from '../models/FindOneMatrixCareHomeHealthAdmissionDemographics200Response';
import {
    type GetHchbPayorForm200Response,
    GetHchbPayorForm200ResponseFromJSON,
    GetHchbPayorForm200ResponseToJSON,
} from '../models/GetHchbPayorForm200Response';
import {
    type GetKinnserLookups200Response,
    GetKinnserLookups200ResponseFromJSON,
    GetKinnserLookups200ResponseToJSON,
} from '../models/GetKinnserLookups200Response';
import {
    type GetKinnserPatient200Response,
    GetKinnserPatient200ResponseFromJSON,
    GetKinnserPatient200ResponseToJSON,
} from '../models/GetKinnserPatient200Response';
import {
    type GetMatrixCareHomeHealthAdmission200Response,
    GetMatrixCareHomeHealthAdmission200ResponseFromJSON,
    GetMatrixCareHomeHealthAdmission200ResponseToJSON,
} from '../models/GetMatrixCareHomeHealthAdmission200Response';
import {
    type GetMatrixCareHomeHealthLookups200Response,
    GetMatrixCareHomeHealthLookups200ResponseFromJSON,
    GetMatrixCareHomeHealthLookups200ResponseToJSON,
} from '../models/GetMatrixCareHomeHealthLookups200Response';
import {
    type LookupZipOptions200Response,
    LookupZipOptions200ResponseFromJSON,
    LookupZipOptions200ResponseToJSON,
} from '../models/LookupZipOptions200Response';
import {
    type MatrixCareAdmissionDemographicsUpdate,
    MatrixCareAdmissionDemographicsUpdateFromJSON,
    MatrixCareAdmissionDemographicsUpdateToJSON,
} from '../models/MatrixCareAdmissionDemographicsUpdate';
import {
    type SearchMatrixCareHomeHealthOrganizations200Response,
    SearchMatrixCareHomeHealthOrganizations200ResponseFromJSON,
    SearchMatrixCareHomeHealthOrganizations200ResponseToJSON,
} from '../models/SearchMatrixCareHomeHealthOrganizations200Response';
import {
    type SearchMatrixCareHomeHealthPatients200Response,
    SearchMatrixCareHomeHealthPatients200ResponseFromJSON,
    SearchMatrixCareHomeHealthPatients200ResponseToJSON,
} from '../models/SearchMatrixCareHomeHealthPatients200Response';
import {
    type SearchPractitioners200Response,
    SearchPractitioners200ResponseFromJSON,
    SearchPractitioners200ResponseToJSON,
} from '../models/SearchPractitioners200Response';
import {
    type StartExecution202Response,
    StartExecution202ResponseFromJSON,
    StartExecution202ResponseToJSON,
} from '../models/StartExecution202Response';
import {
    type StartExecutionRequest,
    StartExecutionRequestFromJSON,
    StartExecutionRequestToJSON,
} from '../models/StartExecutionRequest';
import {
    type UpdateMatrixCareHomeHealthAdmissionDemographics200Response,
    UpdateMatrixCareHomeHealthAdmissionDemographics200ResponseFromJSON,
    UpdateMatrixCareHomeHealthAdmissionDemographics200ResponseToJSON,
} from '../models/UpdateMatrixCareHomeHealthAdmissionDemographics200Response';
import {
    type UploadHchbDocumentsRequest,
    UploadHchbDocumentsRequestFromJSON,
    UploadHchbDocumentsRequestToJSON,
} from '../models/UploadHchbDocumentsRequest';

export interface CreateHchbPatientRequestRequest {
    /**
     * 
     */
    createHchbPatientRequestBody: CreateHchbPatientRequestBody;
}

export interface CreateKinnserPatientOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    createKinnserPatientRequest: CreateKinnserPatientRequest;
}

export interface CreateMatrixCareHomeHealthAdmissionOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * MatrixCare `PatientId`. Must be the patient this lead is linked to.
     */
    patientId: string;
    /**
     * 
     */
    createMatrixCareHomeHealthAdmissionRequest: CreateMatrixCareHomeHealthAdmissionRequest;
}

export interface CreateMatrixCareHomeHealthPatientOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    createMatrixCareHomeHealthPatientRequest: CreateMatrixCareHomeHealthPatientRequest;
}

export interface CreatePractitionerOperationRequest {
    /**
     * 
     */
    createPractitionerRequest: CreatePractitionerRequest;
}

export interface FindAllHchbAdmissionCoordinatorsRequest {
    /**
     * 
     */
    branchId: string;
    /**
     * 
     */
    search?: string;
    /**
     * 
     */
    page?: number;
    /**
     * 
     */
    limit?: number;
}

export interface FindAllHchbBranchesRequest {
    /**
     * 
     */
    facilityId: string;
}

export interface FindAllHchbFacilitiesRequest {
    /**
     * 
     */
    branchId: string;
    /**
     * 
     */
    search?: string;
    /**
     * 
     */
    searchable?: boolean;
    /**
     * 
     */
    isReferringLocation?: boolean;
    /**
     * 
     */
    page?: number;
    /**
     * 
     */
    limit?: number;
}

export interface FindAllHchbPatientRequestsRequest {
    /**
     * 
     */
    leadId: string;
}

export interface FindAllHchbPayorSourcesRequest {
    /**
     * 
     */
    payorTypeName: string;
    /**
     * 
     */
    branchId: string;
    /**
     * 
     */
    search?: string;
    /**
     * 
     */
    serviceLineType?: string;
    /**
     * 
     */
    page?: number;
    /**
     * 
     */
    limit?: number;
}

export interface FindAllHchbPayorTypesRequest {
    /**
     * 
     */
    branchId: string;
    /**
     * 
     */
    search?: string;
    /**
     * 
     */
    serviceLineType?: string;
    /**
     * 
     */
    page?: number;
    /**
     * 
     */
    limit?: number;
}

export interface FindAllHchbPhysiciansRequest {
    /**
     * 
     */
    branchId: string;
    /**
     * 
     */
    search?: string;
    /**
     * 
     */
    searchable?: boolean;
    /**
     * 
     */
    page?: number;
    /**
     * 
     */
    limit?: number;
}

export interface FindAllMatrixCareHomeHealthAdmissionsRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * MatrixCare `PatientId` from a patient-search match.
     */
    patientId: string;
}

export interface FindAllMatrixCareHomeHealthCopySourcesRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * MatrixCare `PatientId` from a patient-search match.
     */
    patientId: string;
    /**
     * Required. MatrixCare `PatientDemoId` from the patient-search match. May be null, in which case this endpoint is unavailable.
     */
    patientDemoId: string;
}

export interface FindCurrentHomeHealthCertificationRequest {
    /**
     * 
     */
    leadId: string;
}

export interface FindOneHchbPatientDetailsRequest {
    /**
     * 
     */
    leadId: string;
}

export interface FindOneMatrixCareHomeHealthAdmissionDemographicsRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    patientId: string;
    /**
     * 
     */
    admissionId: string;
}

export interface GetHchbPayorFormRequest {
    /**
     * HCHB branch code (branch external_id, e.g. FHH).
     */
    branch: string;
    /**
     * HCHB payor type name (e.g. MEDICARE).
     */
    payorType: string;
}

export interface GetKinnserLookupsRequest {
    /**
     * 
     */
    leadId: string;
}

export interface GetKinnserPatientRequest {
    /**
     * 
     */
    leadId: string;
}

export interface GetMatrixCareHomeHealthAdmissionRequest {
    /**
     * 
     */
    leadId: string;
}

export interface GetMatrixCareHomeHealthLookupsRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * When provided, the response includes `lines_of_business` scoped to this BU.
     */
    businessUnitId?: string;
}

export interface LinkMatrixCareHomeHealthPatientRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * MatrixCare `PatientId` from a patient-search match.
     */
    patientId: string;
}

export interface LookupZipOptionsRequest {
    /**
     * 
     */
    branchId: string;
    /**
     * 
     */
    zip: string;
}

export interface SearchMatrixCareHomeHealthOrganizationsRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    businessUnitId: string;
    /**
     * 
     */
    referralSourceId: string;
    /**
     * 
     */
    search: string;
}

export interface SearchMatrixCareHomeHealthPatientsRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * Required. Server-side prefix match on MatrixCare's PatientLastName field.
     */
    lastName: string;
    /**
     * Required. Accepts either `M/D/YYYY` or `YYYY-MM-DD`.
     */
    dateOfBirth: string;
    /**
     * Optional. Server-side prefix match — helps narrow but not required.
     */
    firstName?: string;
}

export interface SearchPractitionersRequest {
    /**
     * 
     */
    search: string;
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    limit?: number;
    /**
     * Restrict results to one source. Omitted returns both, deduplicated by NPI.
     */
    source?: SearchPractitionersSourceEnum;
}

export interface StartExecutionOperationRequest {
    /**
     * 
     */
    startExecutionRequest: StartExecutionRequest;
}

export interface UpdateMatrixCareHomeHealthAdmissionDemographicsRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    patientId: string;
    /**
     * 
     */
    admissionId: string;
    /**
     * 
     */
    matrixCareAdmissionDemographicsUpdate: MatrixCareAdmissionDemographicsUpdate;
}

export interface UploadHchbDocumentsOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    uploadHchbDocumentsRequest: UploadHchbDocumentsRequest;
}

export interface UploadMatrixCareHomeHealthDocumentsRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    uploadHchbDocumentsRequest: UploadHchbDocumentsRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Creates request options for createHchbPatientRequest without sending the request
     */
    async createHchbPatientRequestRequestOpts(requestParameters: CreateHchbPatientRequestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createHchbPatientRequestBody'] == null) {
            throw new runtime.RequiredError(
                'createHchbPatientRequestBody',
                'Required parameter "createHchbPatientRequestBody" was null or undefined when calling createHchbPatientRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/homecare-homebase/patient-requests`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateHchbPatientRequestBodyToJSON(requestParameters['createHchbPatientRequestBody']),
        };
    }

    /**
     * Create an HCHB patient creation request
     */
    async createHchbPatientRequestRaw(requestParameters: CreateHchbPatientRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateHchbPatientRequest201Response>> {
        const requestOptions = await this.createHchbPatientRequestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateHchbPatientRequest201ResponseFromJSON(jsonValue));
    }

    /**
     * Create an HCHB patient creation request
     */
    async createHchbPatientRequest(requestParameters: CreateHchbPatientRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateHchbPatientRequest201Response> {
        const response = await this.createHchbPatientRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createKinnserPatient without sending the request
     */
    async createKinnserPatientRequestOpts(requestParameters: CreateKinnserPatientOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling createKinnserPatient().'
            );
        }

        if (requestParameters['createKinnserPatientRequest'] == null) {
            throw new runtime.RequiredError(
                'createKinnserPatientRequest',
                'Required parameter "createKinnserPatientRequest" was null or undefined when calling createKinnserPatient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/kinnser/leads/{lead_id}/patient`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateKinnserPatientRequestToJSON(requestParameters['createKinnserPatientRequest']),
        };
    }

    /**
     * Start asynchronous Kinnser patient creation
     */
    async createKinnserPatientRaw(requestParameters: CreateKinnserPatientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetKinnserPatient200Response>> {
        const requestOptions = await this.createKinnserPatientRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetKinnserPatient200ResponseFromJSON(jsonValue));
    }

    /**
     * Start asynchronous Kinnser patient creation
     */
    async createKinnserPatient(requestParameters: CreateKinnserPatientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetKinnserPatient200Response> {
        const response = await this.createKinnserPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createMatrixCareHomeHealthAdmission without sending the request
     */
    async createMatrixCareHomeHealthAdmissionRequestOpts(requestParameters: CreateMatrixCareHomeHealthAdmissionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling createMatrixCareHomeHealthAdmission().'
            );
        }

        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling createMatrixCareHomeHealthAdmission().'
            );
        }

        if (requestParameters['createMatrixCareHomeHealthAdmissionRequest'] == null) {
            throw new runtime.RequiredError(
                'createMatrixCareHomeHealthAdmissionRequest',
                'Required parameter "createMatrixCareHomeHealthAdmissionRequest" was null or undefined when calling createMatrixCareHomeHealthAdmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/matrix-care-home-health/leads/{lead_id}/patients/{patient_id}/admissions`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{patient_id}', encodeURIComponent(String(requestParameters['patientId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMatrixCareHomeHealthAdmissionRequestToJSON(requestParameters['createMatrixCareHomeHealthAdmissionRequest']),
        };
    }

    /**
     * Create another admission for a MatrixCare patient by copying an existing one.
     */
    async createMatrixCareHomeHealthAdmissionRaw(requestParameters: CreateMatrixCareHomeHealthAdmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateMatrixCareHomeHealthAdmission201Response>> {
        const requestOptions = await this.createMatrixCareHomeHealthAdmissionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateMatrixCareHomeHealthAdmission201ResponseFromJSON(jsonValue));
    }

    /**
     * Create another admission for a MatrixCare patient by copying an existing one.
     */
    async createMatrixCareHomeHealthAdmission(requestParameters: CreateMatrixCareHomeHealthAdmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateMatrixCareHomeHealthAdmission201Response> {
        const response = await this.createMatrixCareHomeHealthAdmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createMatrixCareHomeHealthPatient without sending the request
     */
    async createMatrixCareHomeHealthPatientRequestOpts(requestParameters: CreateMatrixCareHomeHealthPatientOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling createMatrixCareHomeHealthPatient().'
            );
        }

        if (requestParameters['createMatrixCareHomeHealthPatientRequest'] == null) {
            throw new runtime.RequiredError(
                'createMatrixCareHomeHealthPatientRequest',
                'Required parameter "createMatrixCareHomeHealthPatientRequest" was null or undefined when calling createMatrixCareHomeHealthPatient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/matrix-care-home-health/leads/{lead_id}/patient`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMatrixCareHomeHealthPatientRequestToJSON(requestParameters['createMatrixCareHomeHealthPatientRequest']),
        };
    }

    /**
     * Enqueue a MatrixCare Home Health patient creation. Handled asynchronously by the uploader worker.
     */
    async createMatrixCareHomeHealthPatientRaw(requestParameters: CreateMatrixCareHomeHealthPatientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.createMatrixCareHomeHealthPatientRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Enqueue a MatrixCare Home Health patient creation. Handled asynchronously by the uploader worker.
     */
    async createMatrixCareHomeHealthPatient(requestParameters: CreateMatrixCareHomeHealthPatientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createMatrixCareHomeHealthPatientRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for createPractitioner without sending the request
     */
    async createPractitionerRequestOpts(requestParameters: CreatePractitionerOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createPractitionerRequest'] == null) {
            throw new runtime.RequiredError(
                'createPractitionerRequest',
                'Required parameter "createPractitionerRequest" was null or undefined when calling createPractitioner().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/practitioners`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePractitionerRequestToJSON(requestParameters['createPractitionerRequest']),
        };
    }

    /**
     * Save a practitioner entered manually or selected from NPPES
     */
    async createPractitionerRaw(requestParameters: CreatePractitionerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePractitioner200Response>> {
        const requestOptions = await this.createPractitionerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePractitioner200ResponseFromJSON(jsonValue));
    }

    /**
     * Save a practitioner entered manually or selected from NPPES
     */
    async createPractitioner(requestParameters: CreatePractitionerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePractitioner200Response> {
        const response = await this.createPractitionerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllHchbAdmissionCoordinators without sending the request
     */
    async findAllHchbAdmissionCoordinatorsRequestOpts(requestParameters: FindAllHchbAdmissionCoordinatorsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['branchId'] == null) {
            throw new runtime.RequiredError(
                'branchId',
                'Required parameter "branchId" was null or undefined when calling findAllHchbAdmissionCoordinators().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['branchId'] != null) {
            queryParameters['branch_id'] = requestParameters['branchId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/homecare-homebase/admission-coordinators`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Search HCHB admission coordinators
     */
    async findAllHchbAdmissionCoordinatorsRaw(requestParameters: FindAllHchbAdmissionCoordinatorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHchbAdmissionCoordinators200Response>> {
        const requestOptions = await this.findAllHchbAdmissionCoordinatorsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHchbAdmissionCoordinators200ResponseFromJSON(jsonValue));
    }

    /**
     * Search HCHB admission coordinators
     */
    async findAllHchbAdmissionCoordinators(requestParameters: FindAllHchbAdmissionCoordinatorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHchbAdmissionCoordinators200Response> {
        const response = await this.findAllHchbAdmissionCoordinatorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllHchbBranches without sending the request
     */
    async findAllHchbBranchesRequestOpts(requestParameters: FindAllHchbBranchesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllHchbBranches().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/homecare-homebase/branches`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List HCHB branches with teams for a facility
     */
    async findAllHchbBranchesRaw(requestParameters: FindAllHchbBranchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHchbBranches200Response>> {
        const requestOptions = await this.findAllHchbBranchesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHchbBranches200ResponseFromJSON(jsonValue));
    }

    /**
     * List HCHB branches with teams for a facility
     */
    async findAllHchbBranches(requestParameters: FindAllHchbBranchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHchbBranches200Response> {
        const response = await this.findAllHchbBranchesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllHchbFacilities without sending the request
     */
    async findAllHchbFacilitiesRequestOpts(requestParameters: FindAllHchbFacilitiesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['branchId'] == null) {
            throw new runtime.RequiredError(
                'branchId',
                'Required parameter "branchId" was null or undefined when calling findAllHchbFacilities().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['branchId'] != null) {
            queryParameters['branch_id'] = requestParameters['branchId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['searchable'] != null) {
            queryParameters['searchable'] = requestParameters['searchable'];
        }

        if (requestParameters['isReferringLocation'] != null) {
            queryParameters['is_referring_location'] = requestParameters['isReferringLocation'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/homecare-homebase/facilities`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Search HCHB facilities
     */
    async findAllHchbFacilitiesRaw(requestParameters: FindAllHchbFacilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHchbFacilities200Response>> {
        const requestOptions = await this.findAllHchbFacilitiesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHchbFacilities200ResponseFromJSON(jsonValue));
    }

    /**
     * Search HCHB facilities
     */
    async findAllHchbFacilities(requestParameters: FindAllHchbFacilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHchbFacilities200Response> {
        const response = await this.findAllHchbFacilitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllHchbPatientRequests without sending the request
     */
    async findAllHchbPatientRequestsRequestOpts(requestParameters: FindAllHchbPatientRequestsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findAllHchbPatientRequests().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['leadId'] != null) {
            queryParameters['lead_id'] = requestParameters['leadId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/homecare-homebase/patient-requests`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List HCHB patient requests for a lead
     */
    async findAllHchbPatientRequestsRaw(requestParameters: FindAllHchbPatientRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHchbPatientRequests200Response>> {
        const requestOptions = await this.findAllHchbPatientRequestsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHchbPatientRequests200ResponseFromJSON(jsonValue));
    }

    /**
     * List HCHB patient requests for a lead
     */
    async findAllHchbPatientRequests(requestParameters: FindAllHchbPatientRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHchbPatientRequests200Response> {
        const response = await this.findAllHchbPatientRequestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllHchbPayorSources without sending the request
     */
    async findAllHchbPayorSourcesRequestOpts(requestParameters: FindAllHchbPayorSourcesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['payorTypeName'] == null) {
            throw new runtime.RequiredError(
                'payorTypeName',
                'Required parameter "payorTypeName" was null or undefined when calling findAllHchbPayorSources().'
            );
        }

        if (requestParameters['branchId'] == null) {
            throw new runtime.RequiredError(
                'branchId',
                'Required parameter "branchId" was null or undefined when calling findAllHchbPayorSources().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['payorTypeName'] != null) {
            queryParameters['payor_type_name'] = requestParameters['payorTypeName'];
        }

        if (requestParameters['branchId'] != null) {
            queryParameters['branch_id'] = requestParameters['branchId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['serviceLineType'] != null) {
            queryParameters['service_line_type'] = requestParameters['serviceLineType'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/homecare-homebase/payor-sources`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Search HCHB payor sources
     */
    async findAllHchbPayorSourcesRaw(requestParameters: FindAllHchbPayorSourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHchbPayorSources200Response>> {
        const requestOptions = await this.findAllHchbPayorSourcesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHchbPayorSources200ResponseFromJSON(jsonValue));
    }

    /**
     * Search HCHB payor sources
     */
    async findAllHchbPayorSources(requestParameters: FindAllHchbPayorSourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHchbPayorSources200Response> {
        const response = await this.findAllHchbPayorSourcesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllHchbPayorTypes without sending the request
     */
    async findAllHchbPayorTypesRequestOpts(requestParameters: FindAllHchbPayorTypesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['branchId'] == null) {
            throw new runtime.RequiredError(
                'branchId',
                'Required parameter "branchId" was null or undefined when calling findAllHchbPayorTypes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['branchId'] != null) {
            queryParameters['branch_id'] = requestParameters['branchId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['serviceLineType'] != null) {
            queryParameters['service_line_type'] = requestParameters['serviceLineType'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/homecare-homebase/payor-types`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Search HCHB payor types
     */
    async findAllHchbPayorTypesRaw(requestParameters: FindAllHchbPayorTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHchbPayorTypes200Response>> {
        const requestOptions = await this.findAllHchbPayorTypesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHchbPayorTypes200ResponseFromJSON(jsonValue));
    }

    /**
     * Search HCHB payor types
     */
    async findAllHchbPayorTypes(requestParameters: FindAllHchbPayorTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHchbPayorTypes200Response> {
        const response = await this.findAllHchbPayorTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllHchbPhysicians without sending the request
     */
    async findAllHchbPhysiciansRequestOpts(requestParameters: FindAllHchbPhysiciansRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['branchId'] == null) {
            throw new runtime.RequiredError(
                'branchId',
                'Required parameter "branchId" was null or undefined when calling findAllHchbPhysicians().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['branchId'] != null) {
            queryParameters['branch_id'] = requestParameters['branchId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['searchable'] != null) {
            queryParameters['searchable'] = requestParameters['searchable'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/homecare-homebase/physicians`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Search HCHB physicians
     */
    async findAllHchbPhysiciansRaw(requestParameters: FindAllHchbPhysiciansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHchbPhysicians200Response>> {
        const requestOptions = await this.findAllHchbPhysiciansRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHchbPhysicians200ResponseFromJSON(jsonValue));
    }

    /**
     * Search HCHB physicians
     */
    async findAllHchbPhysicians(requestParameters: FindAllHchbPhysiciansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHchbPhysicians200Response> {
        const response = await this.findAllHchbPhysiciansRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllMatrixCareHomeHealthAdmissions without sending the request
     */
    async findAllMatrixCareHomeHealthAdmissionsRequestOpts(requestParameters: FindAllMatrixCareHomeHealthAdmissionsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findAllMatrixCareHomeHealthAdmissions().'
            );
        }

        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling findAllMatrixCareHomeHealthAdmissions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/matrix-care-home-health/leads/{lead_id}/patients/{patient_id}/admissions`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{patient_id}', encodeURIComponent(String(requestParameters['patientId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List a MatrixCare patient\'s admissions, read live from MatrixCare.
     */
    async findAllMatrixCareHomeHealthAdmissionsRaw(requestParameters: FindAllMatrixCareHomeHealthAdmissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllMatrixCareHomeHealthAdmissions200Response>> {
        const requestOptions = await this.findAllMatrixCareHomeHealthAdmissionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllMatrixCareHomeHealthAdmissions200ResponseFromJSON(jsonValue));
    }

    /**
     * List a MatrixCare patient\'s admissions, read live from MatrixCare.
     */
    async findAllMatrixCareHomeHealthAdmissions(requestParameters: FindAllMatrixCareHomeHealthAdmissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllMatrixCareHomeHealthAdmissions200Response> {
        const response = await this.findAllMatrixCareHomeHealthAdmissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllMatrixCareHomeHealthCopySources without sending the request
     */
    async findAllMatrixCareHomeHealthCopySourcesRequestOpts(requestParameters: FindAllMatrixCareHomeHealthCopySourcesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findAllMatrixCareHomeHealthCopySources().'
            );
        }

        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling findAllMatrixCareHomeHealthCopySources().'
            );
        }

        if (requestParameters['patientDemoId'] == null) {
            throw new runtime.RequiredError(
                'patientDemoId',
                'Required parameter "patientDemoId" was null or undefined when calling findAllMatrixCareHomeHealthCopySources().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['patientDemoId'] != null) {
            queryParameters['patient_demo_id'] = requestParameters['patientDemoId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/matrix-care-home-health/leads/{lead_id}/patients/{patient_id}/copy-sources`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{patient_id}', encodeURIComponent(String(requestParameters['patientId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List admissions MatrixCare accepts as a copy source for a new admission.
     */
    async findAllMatrixCareHomeHealthCopySourcesRaw(requestParameters: FindAllMatrixCareHomeHealthCopySourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllMatrixCareHomeHealthCopySources200Response>> {
        const requestOptions = await this.findAllMatrixCareHomeHealthCopySourcesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllMatrixCareHomeHealthCopySources200ResponseFromJSON(jsonValue));
    }

    /**
     * List admissions MatrixCare accepts as a copy source for a new admission.
     */
    async findAllMatrixCareHomeHealthCopySources(requestParameters: FindAllMatrixCareHomeHealthCopySourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllMatrixCareHomeHealthCopySources200Response> {
        const response = await this.findAllMatrixCareHomeHealthCopySourcesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findCurrentHomeHealthCertification without sending the request
     */
    async findCurrentHomeHealthCertificationRequestOpts(requestParameters: FindCurrentHomeHealthCertificationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findCurrentHomeHealthCertification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/home-health-certification`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get the current Home Health certification extraction for a lead.
     */
    async findCurrentHomeHealthCertificationRaw(requestParameters: FindCurrentHomeHealthCertificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindCurrentHomeHealthCertification200Response>> {
        const requestOptions = await this.findCurrentHomeHealthCertificationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindCurrentHomeHealthCertification200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the current Home Health certification extraction for a lead.
     */
    async findCurrentHomeHealthCertification(requestParameters: FindCurrentHomeHealthCertificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindCurrentHomeHealthCertification200Response> {
        const response = await this.findCurrentHomeHealthCertificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findOneHchbPatientDetails without sending the request
     */
    async findOneHchbPatientDetailsRequestOpts(requestParameters: FindOneHchbPatientDetailsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findOneHchbPatientDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/homecare-homebase/leads/{lead_id}/patient-details`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find One HCHB patient\'s details
     */
    async findOneHchbPatientDetailsRaw(requestParameters: FindOneHchbPatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneHchbPatientDetails200Response>> {
        const requestOptions = await this.findOneHchbPatientDetailsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneHchbPatientDetails200ResponseFromJSON(jsonValue));
    }

    /**
     * Find One HCHB patient\'s details
     */
    async findOneHchbPatientDetails(requestParameters: FindOneHchbPatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneHchbPatientDetails200Response> {
        const response = await this.findOneHchbPatientDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findOneMatrixCareHomeHealthAdmissionDemographics without sending the request
     */
    async findOneMatrixCareHomeHealthAdmissionDemographicsRequestOpts(requestParameters: FindOneMatrixCareHomeHealthAdmissionDemographicsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findOneMatrixCareHomeHealthAdmissionDemographics().'
            );
        }

        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling findOneMatrixCareHomeHealthAdmissionDemographics().'
            );
        }

        if (requestParameters['admissionId'] == null) {
            throw new runtime.RequiredError(
                'admissionId',
                'Required parameter "admissionId" was null or undefined when calling findOneMatrixCareHomeHealthAdmissionDemographics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/matrix-care-home-health/leads/{lead_id}/patients/{patient_id}/admissions/{admission_id}/demographics`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{patient_id}', encodeURIComponent(String(requestParameters['patientId'])));
        urlPath = urlPath.replace('{admission_id}', encodeURIComponent(String(requestParameters['admissionId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Read an admission\'s demographics live from MatrixCare.
     */
    async findOneMatrixCareHomeHealthAdmissionDemographicsRaw(requestParameters: FindOneMatrixCareHomeHealthAdmissionDemographicsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneMatrixCareHomeHealthAdmissionDemographics200Response>> {
        const requestOptions = await this.findOneMatrixCareHomeHealthAdmissionDemographicsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneMatrixCareHomeHealthAdmissionDemographics200ResponseFromJSON(jsonValue));
    }

    /**
     * Read an admission\'s demographics live from MatrixCare.
     */
    async findOneMatrixCareHomeHealthAdmissionDemographics(requestParameters: FindOneMatrixCareHomeHealthAdmissionDemographicsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneMatrixCareHomeHealthAdmissionDemographics200Response> {
        const response = await this.findOneMatrixCareHomeHealthAdmissionDemographicsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getHchbPayorForm without sending the request
     */
    async getHchbPayorFormRequestOpts(requestParameters: GetHchbPayorFormRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['branch'] == null) {
            throw new runtime.RequiredError(
                'branch',
                'Required parameter "branch" was null or undefined when calling getHchbPayorForm().'
            );
        }

        if (requestParameters['payorType'] == null) {
            throw new runtime.RequiredError(
                'payorType',
                'Required parameter "payorType" was null or undefined when calling getHchbPayorForm().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['branch'] != null) {
            queryParameters['branch'] = requestParameters['branch'];
        }

        if (requestParameters['payorType'] != null) {
            queryParameters['payor_type'] = requestParameters['payorType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/homecare-homebase/payor-form`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get payor form
     */
    async getHchbPayorFormRaw(requestParameters: GetHchbPayorFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetHchbPayorForm200Response>> {
        const requestOptions = await this.getHchbPayorFormRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetHchbPayorForm200ResponseFromJSON(jsonValue));
    }

    /**
     * Get payor form
     */
    async getHchbPayorForm(requestParameters: GetHchbPayorFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetHchbPayorForm200Response> {
        const response = await this.getHchbPayorFormRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getKinnserLookups without sending the request
     */
    async getKinnserLookupsRequestOpts(requestParameters: GetKinnserLookupsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getKinnserLookups().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/kinnser/leads/{lead_id}/lookups`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get cached WellSky Kinnser patient form options
     */
    async getKinnserLookupsRaw(requestParameters: GetKinnserLookupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetKinnserLookups200Response>> {
        const requestOptions = await this.getKinnserLookupsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetKinnserLookups200ResponseFromJSON(jsonValue));
    }

    /**
     * Get cached WellSky Kinnser patient form options
     */
    async getKinnserLookups(requestParameters: GetKinnserLookupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetKinnserLookups200Response> {
        const response = await this.getKinnserLookupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getKinnserPatient without sending the request
     */
    async getKinnserPatientRequestOpts(requestParameters: GetKinnserPatientRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getKinnserPatient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/kinnser/leads/{lead_id}/patient`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Kinnser patient creation status and linked patient details
     */
    async getKinnserPatientRaw(requestParameters: GetKinnserPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetKinnserPatient200Response>> {
        const requestOptions = await this.getKinnserPatientRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetKinnserPatient200ResponseFromJSON(jsonValue));
    }

    /**
     * Get Kinnser patient creation status and linked patient details
     */
    async getKinnserPatient(requestParameters: GetKinnserPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetKinnserPatient200Response> {
        const response = await this.getKinnserPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMatrixCareHomeHealthAdmission without sending the request
     */
    async getMatrixCareHomeHealthAdmissionRequestOpts(requestParameters: GetMatrixCareHomeHealthAdmissionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getMatrixCareHomeHealthAdmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/matrix-care-home-health/leads/{lead_id}/admission`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get the latest MatrixCare Home Health admission for a lead.
     */
    async getMatrixCareHomeHealthAdmissionRaw(requestParameters: GetMatrixCareHomeHealthAdmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMatrixCareHomeHealthAdmission200Response>> {
        const requestOptions = await this.getMatrixCareHomeHealthAdmissionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMatrixCareHomeHealthAdmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the latest MatrixCare Home Health admission for a lead.
     */
    async getMatrixCareHomeHealthAdmission(requestParameters: GetMatrixCareHomeHealthAdmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMatrixCareHomeHealthAdmission200Response> {
        const response = await this.getMatrixCareHomeHealthAdmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMatrixCareHomeHealthLookups without sending the request
     */
    async getMatrixCareHomeHealthLookupsRequestOpts(requestParameters: GetMatrixCareHomeHealthLookupsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getMatrixCareHomeHealthLookups().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['businessUnitId'] != null) {
            queryParameters['business_unit_id'] = requestParameters['businessUnitId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/matrix-care-home-health/leads/{lead_id}/lookups`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch all picklists needed to render the MatrixCare Home Health create-patient form.
     */
    async getMatrixCareHomeHealthLookupsRaw(requestParameters: GetMatrixCareHomeHealthLookupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMatrixCareHomeHealthLookups200Response>> {
        const requestOptions = await this.getMatrixCareHomeHealthLookupsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMatrixCareHomeHealthLookups200ResponseFromJSON(jsonValue));
    }

    /**
     * Fetch all picklists needed to render the MatrixCare Home Health create-patient form.
     */
    async getMatrixCareHomeHealthLookups(requestParameters: GetMatrixCareHomeHealthLookupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMatrixCareHomeHealthLookups200Response> {
        const response = await this.getMatrixCareHomeHealthLookupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for linkMatrixCareHomeHealthPatient without sending the request
     */
    async linkMatrixCareHomeHealthPatientRequestOpts(requestParameters: LinkMatrixCareHomeHealthPatientRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling linkMatrixCareHomeHealthPatient().'
            );
        }

        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling linkMatrixCareHomeHealthPatient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/matrix-care-home-health/leads/{lead_id}/patients/{patient_id}/link`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{patient_id}', encodeURIComponent(String(requestParameters['patientId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Writes only to ExaCare. Re-reads the patient\'s admissions from MatrixCare at link time, so the imported set reflects the vendor rather than a stale client view. Safe to retry: linking the same patient again returns the same link.
     * Link a lead to an existing MatrixCare patient and import their admissions.
     */
    async linkMatrixCareHomeHealthPatientRaw(requestParameters: LinkMatrixCareHomeHealthPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMatrixCareHomeHealthAdmission200Response>> {
        const requestOptions = await this.linkMatrixCareHomeHealthPatientRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMatrixCareHomeHealthAdmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Writes only to ExaCare. Re-reads the patient\'s admissions from MatrixCare at link time, so the imported set reflects the vendor rather than a stale client view. Safe to retry: linking the same patient again returns the same link.
     * Link a lead to an existing MatrixCare patient and import their admissions.
     */
    async linkMatrixCareHomeHealthPatient(requestParameters: LinkMatrixCareHomeHealthPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMatrixCareHomeHealthAdmission200Response> {
        const response = await this.linkMatrixCareHomeHealthPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for lookupZipOptions without sending the request
     */
    async lookupZipOptionsRequestOpts(requestParameters: LookupZipOptionsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['branchId'] == null) {
            throw new runtime.RequiredError(
                'branchId',
                'Required parameter "branchId" was null or undefined when calling lookupZipOptions().'
            );
        }

        if (requestParameters['zip'] == null) {
            throw new runtime.RequiredError(
                'zip',
                'Required parameter "zip" was null or undefined when calling lookupZipOptions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['branchId'] != null) {
            queryParameters['branch_id'] = requestParameters['branchId'];
        }

        if (requestParameters['zip'] != null) {
            queryParameters['zip'] = requestParameters['zip'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/homecare-homebase/zip-lookup`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Look up city/state/county options for a zip code
     */
    async lookupZipOptionsRaw(requestParameters: LookupZipOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LookupZipOptions200Response>> {
        const requestOptions = await this.lookupZipOptionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LookupZipOptions200ResponseFromJSON(jsonValue));
    }

    /**
     * Look up city/state/county options for a zip code
     */
    async lookupZipOptions(requestParameters: LookupZipOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LookupZipOptions200Response> {
        const response = await this.lookupZipOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchMatrixCareHomeHealthOrganizations without sending the request
     */
    async searchMatrixCareHomeHealthOrganizationsRequestOpts(requestParameters: SearchMatrixCareHomeHealthOrganizationsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling searchMatrixCareHomeHealthOrganizations().'
            );
        }

        if (requestParameters['businessUnitId'] == null) {
            throw new runtime.RequiredError(
                'businessUnitId',
                'Required parameter "businessUnitId" was null or undefined when calling searchMatrixCareHomeHealthOrganizations().'
            );
        }

        if (requestParameters['referralSourceId'] == null) {
            throw new runtime.RequiredError(
                'referralSourceId',
                'Required parameter "referralSourceId" was null or undefined when calling searchMatrixCareHomeHealthOrganizations().'
            );
        }

        if (requestParameters['search'] == null) {
            throw new runtime.RequiredError(
                'search',
                'Required parameter "search" was null or undefined when calling searchMatrixCareHomeHealthOrganizations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['businessUnitId'] != null) {
            queryParameters['business_unit_id'] = requestParameters['businessUnitId'];
        }

        if (requestParameters['referralSourceId'] != null) {
            queryParameters['referral_source_id'] = requestParameters['referralSourceId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/matrix-care-home-health/leads/{lead_id}/organizations`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Search MatrixCare Home Health referral organizations.
     */
    async searchMatrixCareHomeHealthOrganizationsRaw(requestParameters: SearchMatrixCareHomeHealthOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchMatrixCareHomeHealthOrganizations200Response>> {
        const requestOptions = await this.searchMatrixCareHomeHealthOrganizationsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchMatrixCareHomeHealthOrganizations200ResponseFromJSON(jsonValue));
    }

    /**
     * Search MatrixCare Home Health referral organizations.
     */
    async searchMatrixCareHomeHealthOrganizations(requestParameters: SearchMatrixCareHomeHealthOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchMatrixCareHomeHealthOrganizations200Response> {
        const response = await this.searchMatrixCareHomeHealthOrganizationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchMatrixCareHomeHealthPatients without sending the request
     */
    async searchMatrixCareHomeHealthPatientsRequestOpts(requestParameters: SearchMatrixCareHomeHealthPatientsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling searchMatrixCareHomeHealthPatients().'
            );
        }

        if (requestParameters['lastName'] == null) {
            throw new runtime.RequiredError(
                'lastName',
                'Required parameter "lastName" was null or undefined when calling searchMatrixCareHomeHealthPatients().'
            );
        }

        if (requestParameters['dateOfBirth'] == null) {
            throw new runtime.RequiredError(
                'dateOfBirth',
                'Required parameter "dateOfBirth" was null or undefined when calling searchMatrixCareHomeHealthPatients().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['lastName'] != null) {
            queryParameters['last_name'] = requestParameters['lastName'];
        }

        if (requestParameters['dateOfBirth'] != null) {
            queryParameters['date_of_birth'] = requestParameters['dateOfBirth'];
        }

        if (requestParameters['firstName'] != null) {
            queryParameters['first_name'] = requestParameters['firstName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/matrix-care-home-health/leads/{lead_id}/patient-search`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Search MatrixCare Home Health for possibly-existing patients matching the lead\'s demographics.
     */
    async searchMatrixCareHomeHealthPatientsRaw(requestParameters: SearchMatrixCareHomeHealthPatientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchMatrixCareHomeHealthPatients200Response>> {
        const requestOptions = await this.searchMatrixCareHomeHealthPatientsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchMatrixCareHomeHealthPatients200ResponseFromJSON(jsonValue));
    }

    /**
     * Search MatrixCare Home Health for possibly-existing patients matching the lead\'s demographics.
     */
    async searchMatrixCareHomeHealthPatients(requestParameters: SearchMatrixCareHomeHealthPatientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchMatrixCareHomeHealthPatients200Response> {
        const response = await this.searchMatrixCareHomeHealthPatientsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchPractitioners without sending the request
     */
    async searchPractitionersRequestOpts(requestParameters: SearchPractitionersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['search'] == null) {
            throw new runtime.RequiredError(
                'search',
                'Required parameter "search" was null or undefined when calling searchPractitioners().'
            );
        }

        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling searchPractitioners().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/practitioners`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Search practitioners across saved records and the NPPES registry
     */
    async searchPractitionersRaw(requestParameters: SearchPractitionersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchPractitioners200Response>> {
        const requestOptions = await this.searchPractitionersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchPractitioners200ResponseFromJSON(jsonValue));
    }

    /**
     * Search practitioners across saved records and the NPPES registry
     */
    async searchPractitioners(requestParameters: SearchPractitionersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchPractitioners200Response> {
        const response = await this.searchPractitionersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for startExecution without sending the request
     */
    async startExecutionRequestOpts(requestParameters: StartExecutionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['startExecutionRequest'] == null) {
            throw new runtime.RequiredError(
                'startExecutionRequest',
                'Required parameter "startExecutionRequest" was null or undefined when calling startExecution().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/homecare-homebase/executions`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StartExecutionRequestToJSON(requestParameters['startExecutionRequest']),
        };
    }

    /**
     * Start an HCHB automation execution
     */
    async startExecutionRaw(requestParameters: StartExecutionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartExecution202Response>> {
        const requestOptions = await this.startExecutionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StartExecution202ResponseFromJSON(jsonValue));
    }

    /**
     * Start an HCHB automation execution
     */
    async startExecution(requestParameters: StartExecutionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartExecution202Response> {
        const response = await this.startExecutionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateMatrixCareHomeHealthAdmissionDemographics without sending the request
     */
    async updateMatrixCareHomeHealthAdmissionDemographicsRequestOpts(requestParameters: UpdateMatrixCareHomeHealthAdmissionDemographicsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling updateMatrixCareHomeHealthAdmissionDemographics().'
            );
        }

        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling updateMatrixCareHomeHealthAdmissionDemographics().'
            );
        }

        if (requestParameters['admissionId'] == null) {
            throw new runtime.RequiredError(
                'admissionId',
                'Required parameter "admissionId" was null or undefined when calling updateMatrixCareHomeHealthAdmissionDemographics().'
            );
        }

        if (requestParameters['matrixCareAdmissionDemographicsUpdate'] == null) {
            throw new runtime.RequiredError(
                'matrixCareAdmissionDemographicsUpdate',
                'Required parameter "matrixCareAdmissionDemographicsUpdate" was null or undefined when calling updateMatrixCareHomeHealthAdmissionDemographics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/matrix-care-home-health/leads/{lead_id}/patients/{patient_id}/admissions/{admission_id}/demographics`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{patient_id}', encodeURIComponent(String(requestParameters['patientId'])));
        urlPath = urlPath.replace('{admission_id}', encodeURIComponent(String(requestParameters['admissionId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: MatrixCareAdmissionDemographicsUpdateToJSON(requestParameters['matrixCareAdmissionDemographicsUpdate']),
        };
    }

    /**
     * Update an admission\'s demographics in MatrixCare.
     */
    async updateMatrixCareHomeHealthAdmissionDemographicsRaw(requestParameters: UpdateMatrixCareHomeHealthAdmissionDemographicsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateMatrixCareHomeHealthAdmissionDemographics200Response>> {
        const requestOptions = await this.updateMatrixCareHomeHealthAdmissionDemographicsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateMatrixCareHomeHealthAdmissionDemographics200ResponseFromJSON(jsonValue));
    }

    /**
     * Update an admission\'s demographics in MatrixCare.
     */
    async updateMatrixCareHomeHealthAdmissionDemographics(requestParameters: UpdateMatrixCareHomeHealthAdmissionDemographicsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateMatrixCareHomeHealthAdmissionDemographics200Response> {
        const response = await this.updateMatrixCareHomeHealthAdmissionDemographicsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uploadHchbDocuments without sending the request
     */
    async uploadHchbDocumentsRequestOpts(requestParameters: UploadHchbDocumentsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling uploadHchbDocuments().'
            );
        }

        if (requestParameters['uploadHchbDocumentsRequest'] == null) {
            throw new runtime.RequiredError(
                'uploadHchbDocumentsRequest',
                'Required parameter "uploadHchbDocumentsRequest" was null or undefined when calling uploadHchbDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/homecare-homebase/leads/{lead_id}/patient-documents`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadHchbDocumentsRequestToJSON(requestParameters['uploadHchbDocumentsRequest']),
        };
    }

    /**
     * Upload documents to HCHB
     */
    async uploadHchbDocumentsRaw(requestParameters: UploadHchbDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneHchbPatientDetails200Response>> {
        const requestOptions = await this.uploadHchbDocumentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneHchbPatientDetails200ResponseFromJSON(jsonValue));
    }

    /**
     * Upload documents to HCHB
     */
    async uploadHchbDocuments(requestParameters: UploadHchbDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneHchbPatientDetails200Response> {
        const response = await this.uploadHchbDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uploadMatrixCareHomeHealthDocuments without sending the request
     */
    async uploadMatrixCareHomeHealthDocumentsRequestOpts(requestParameters: UploadMatrixCareHomeHealthDocumentsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling uploadMatrixCareHomeHealthDocuments().'
            );
        }

        if (requestParameters['uploadHchbDocumentsRequest'] == null) {
            throw new runtime.RequiredError(
                'uploadHchbDocumentsRequest',
                'Required parameter "uploadHchbDocumentsRequest" was null or undefined when calling uploadMatrixCareHomeHealthDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/matrix-care-home-health/leads/{lead_id}/patient/details`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadHchbDocumentsRequestToJSON(requestParameters['uploadHchbDocumentsRequest']),
        };
    }

    /**
     * Enqueue documents to be pushed to MatrixCare Home Health.
     */
    async uploadMatrixCareHomeHealthDocumentsRaw(requestParameters: UploadMatrixCareHomeHealthDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.uploadMatrixCareHomeHealthDocumentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Enqueue documents to be pushed to MatrixCare Home Health.
     */
    async uploadMatrixCareHomeHealthDocuments(requestParameters: UploadMatrixCareHomeHealthDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uploadMatrixCareHomeHealthDocumentsRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const SearchPractitionersSourceEnum = {
    Local: 'local',
    Nppes: 'nppes',
} as const;
export type SearchPractitionersSourceEnum = typeof SearchPractitionersSourceEnum[keyof typeof SearchPractitionersSourceEnum];
